import { Button, Flex, Spacing, Text } from '@billy/design-system'
import { ReactElement } from 'react'
import { useTranslation } from 'react-i18next'

interface FecImportMappingLoadErrorProps {
  isRetrying: boolean
  messageKey: string
  onRetry: () => void
}

export const FecImportMappingLoadError = ({
  isRetrying,
  messageKey,
  onRetry,
}: FecImportMappingLoadErrorProps): ReactElement => {
  const { t } = useTranslation()

  return (
    <Flex alignItems="center" flexDirection="column" gap={Spacing.S16}>
      <Text colorVariant="secondary" variant="bodyMD">
        {t(messageKey)}
      </Text>
      <Button disabled={isRetrying} loading={isRetrying} onClick={onRetry} variant="filled">
        {t('settings.organization.accounting.fec_file_import.modal.retry_button')}
      </Button>
    </Flex>
  )
}
